import { path } from 'ramda';

import type {
  Color,
  ColorOrVariable,
  ColorVariablePaths,
  ColorVariables,
  ThemeType,
} from 'common/types/Styles';

export const getColorVariable = (
  dotPath: ColorVariablePaths | string,
  colorVariables: ColorVariables,
) => {
  const pathArray = dotPath.split('.');
  return path(pathArray, colorVariables) as string | undefined;
};

const isColor = (color: ColorOrVariable | string, theme: ThemeType): color is Color =>
  color in theme.color;

export const getColorOrVariable = (color: ColorOrVariable | string, theme: ThemeType) => {
  if (isColor(color, theme)) {
    return theme.color[color];
  }

  return getColorVariable(color, theme.variables.color) ?? undefined;
};
